import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { pipe } from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { ApiResponse } from '../../entities/api-response.entity/api-response';
import { AuthService } from '../../../services/auth.service/auth.service';
import { PageRequest } from 'src/app/common/modules/data-table.module';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(public http: HttpClient) { }

  responsePipe = pipe(
    tap((res: ApiResponse) => {
      if (!res.success) throw { kind: res.kind, message: res.message, data: res.data };
    }),
    map((res: ApiResponse) => res.data)
  )

  protected  getPageRequestHttpOptions(pageRequest?: PageRequest,params:HttpParams = new HttpParams()): HttpParams {
    return params.append('page', pageRequest?.pageOffset || 0).append('size',pageRequest?.pageSize || 10);
  }
}
